import { Component, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';

@Component({
  selector: 'app-cookie-banner',
  templateUrl: './cookie-banner.component.html',
  styleUrls: ['./cookie-banner.component.css'],
})
export class CookieBannerComponent implements OnInit {
  mostrarBanner = false;
  mensagem = '';

  constructor(private http: HttpClient) {}

  ngOnInit(): void {
    console.log('CookieBannerComponent: Iniciando...');
    const aceitou = localStorage.getItem('calendario_mensagem_ok');
    console.log('CookieBannerComponent: Valor do localStorage:', aceitou);
    
    if (aceitou === '1') {
      console.log('CookieBannerComponent: Usuário já aceitou, não exibindo banner');
      return;
    }

    console.log('CookieBannerComponent: Buscando mensagem do servidor...');
    this.http.get<any>('https://cdn.funceme.br/assets/json/cookies.json').subscribe({
      next: (data) => {
        console.log('CookieBannerComponent: Dados recebidos:', data);
        this.mensagem = data.mensagem;
        this.mostrarBanner = true;
        console.log('CookieBannerComponent: Banner configurado para exibição');
      },
      error: (err) => {
        console.error('CookieBannerComponent: Erro ao carregar mensagem:', err);
      },
    });
  }

  aceitar(): void {
    console.log('CookieBannerComponent: Usuário aceitou o banner');
    localStorage.setItem('calendario_mensagem_ok', '1');
    this.mostrarBanner = false;
  }
}
